import axios, { AxiosRequestHeaders } from "axios";
import { tokenService } from "./tokenService";
import { TokenResponse } from "../types/auth";

const api = axios.create({

  baseURL: process.env.REACT_APP_API_URL ,

});

const token = tokenService.getToken();
if (token) {
  api.defaults.headers.common["Authorization"] = `Bearer ${token.access}`;
}

api.interceptors.request.use(
  (config) => {
    const token = tokenService.getToken();
    if (token) {
      if (!config.headers) {
        config.headers = {} as AxiosRequestHeaders;
      }
      config.headers["Authorization"] = `Bearer ${token.access}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Verifica se o erro é 401 (Unauthorized) e se já não é uma tentativa de retry
    if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true;
      const token = tokenService.getToken();

      if (token?.refresh) {
        try {
          // Tenta obter um novo access token usando o refresh token
          // Usamos axios.post direto para evitar loop com os interceptors da instância 'api'
          const { data } = await api.post( '/api/auth/token/refresh/', {
            refresh: token.refresh,
          });

          if (data.access) {
            // Atualiza o token no localStorage mantendo o refresh token antigo
            const newToken = { ...token, access: data.access };
            tokenService.setToken(newToken);

            // Atualiza o header de autorização da instância e da requisição original
            api.defaults.headers.common["Authorization"] = `Bearer ${data.access}`;
            originalRequest.headers["Authorization"] = `Bearer ${data.access}`;

            // Refaz a requisição original com o novo token
            return api(originalRequest);
          }
        } catch (refreshError) {
          // Se o refresh falhar (ex: refresh token também expirou), segue para o logout abaixo
          console.error("Falha ao renovar token:", refreshError);
        }
      }
    }

    if (error.response?.status === 401) {
      tokenService.removeToken();
      delete api.defaults.headers.common["Authorization"];

      // Força redirecionamento mesmo que já esteja na rota de login
      const currentPath = window.location.pathname;
      if (!currentPath.includes("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
